import _extends from 'babel-runtime/helpers/extends';
import router from './router';
import store from './store';
import NProgress from 'nprogress'; // Progress 进度条
import 'nprogress/nprogress.css'; // Progress 进度条样式
import { Message } from 'element-ui';
import { getAuth } from '@/utils/auth'; // 验权

var loadAsyncRouter = false;
var whiteList = ['/login', '/welcome']; // 不重定向白名单
router.beforeEach(function (to, from, next) {
  if (to.meta.disabled) {
    next(false);
    return;
  }
  NProgress.start();
  /** 请求头包含授权信息 并且 页面必须授权 直接进入 */
  if (getAuth()) {
    if (whiteList.includes(to.path)) {
      next({
        path: '/'
      });
      NProgress.done();
    } else {
      if (!loadAsyncRouter) {
        // 判断当前用户是否获取权限
        loadAsyncRouter = true;
        if (store.getters.allAuth) {
          store.dispatch('GenerateRoutes', store.getters.allAuth).then(function () {
            // 根据auths权限生成可访问的路由表
            router.addRoutes(store.getters.addRouters); // 动态添加可访问路由表
            if (to.path === '/404') {
              next({
                path: to.redirectedFrom || '/',
                replace: true
              });
            } else {
              next(_extends({}, to, {
                replace: true
              }));
            }
          });
        } else {
          store.dispatch('getAuth').then(function (auths) {
            // 拉取user_info
            store.dispatch('GenerateRoutes', auths).then(function () {
              // 根据auths权限生成可访问的路由表
              router.addRoutes(store.getters.addRouters); // 动态添加可访问路由表
              if (to.path === '/404') {
                next({
                  path: to.redirectedFrom || '/',
                  replace: true
                });
              } else {
                next(_extends({}, to, {
                  replace: true
                }));
              }
            });
          }).catch(function (err) {
            loadAsyncRouter = false;
            store.dispatch('LogOut').then(function () {
              Message.error(err.msg || '获取用户信息失败');
              next({
                path: '/'
              });
            });
          });
        }
      } else {
        next();
      }
    }
  } else {
    if (whiteList.indexOf(to.path) !== -1) {
      next();
    } else {
      next('/login'); // 否则全部重定向到登录页
      NProgress.done();
    }
  }
});

router.afterEach(function () {
  NProgress.done(); // 结束Progress
});

router.onError(function (error) {
  var pattern = /Loading chunk (\d)+ failed/g;
  var isChunkLoadFailed = error.message.match(pattern);
  var targetPath = router.history.pending.fullPath;
  if (isChunkLoadFailed) {
    router.replace(targetPath);
  }
});